export default __webpack_public_path__ + "static/media/dribbble.64d389a3.webp";